<template>
  <Modal v-model="viewUsersModal" :title="$t('key1005854')" width="1100" :transfer="false" footer-hide @on-visible-change="viewUsersChange">
    <local-tabButton :tabButtonList="enableDisableList" @selectStatus="enableDisableStatusBtn"></local-tabButton>
    <Table
      class="mt20"
      border
      max-height="520"
      :loading="tableLoading"
      :columns="tableColumns"
      :data="tableData">
    </Table>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';

export default {
  name: "viewUsersModal",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      viewUsersModal: false,
      tableColumns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002629'),
          key: 'mobile',
          minWidth: 130,
          align: 'left'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002342'),
          key: 'email',
          align: 'left',
          minWidth: 170
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002331'),
          key: 'userName',
          minWidth: 130,
          align: 'left'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005850'),
          key: 'accountType',
          align: 'left',
          minWidth: 110,
          render(h, params) {
            let text = '';
            let isAdmin = params.row.isAdmin === '1';
            text = isAdmin ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005851') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005852');
            return h('span', {class: isAdmin ? 'distributorThemeColor' : ''}, text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005853'),
          key: 'roleName',
          align: 'left',
          minWidth: 130
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000461'),
          key: 'status',
          align: 'left',
          minWidth: 100,
          render(h, params) {
            let typeList = [
              {type: 'error', text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000463')},
              {type: 'success', text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000462')}
            ];
            let status = params.row.status;
            return h('Badge', {
              props: {
                status: typeList[status].type,
                text: typeList[status].text || '--'
              }
            });
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005167'),
          key: 'lastLoginTime',
          align: 'left',
          minWidth: 170,
          render: (h, params) => {
            return h('div', v.$uDate.dealTime(params.row.lastLoginTime, 'fulltime'));
          }
        },
      ],
      tableData: [],
      enableDisableList: [
        {selected: true, value: 1, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002630')},
        {selected: false, value: 0, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002631')},
      ],
      originalData: [],
    };
  },
  methods: {
    // 初始化数据
    initFun(data) {
      if (data && data.length > 0) {
        this.originalData = data;
        this.tableData = data.filter((item) => {
          return item.status === 1;
        });
      }
      this.viewUsersModal = true;
    },
    // 切换状态
    enableDisableStatusBtn(index, value) {
      let v = this;
      v.enableDisableList.forEach((n, i) => {
        n.selected = i === index;
        if (v.originalData.length > 0) {
          let list = v.originalData.filter((item) => {
            if (item.status === value) {
              return item;
            }
          });
          v.tableData = list;
        }
      });
    },
    // 监听弹窗
    viewUsersChange(value) {
      if (!value) {
        this.enableDisableStatusBtn(0, 1);
        this.tableData = [];
        this.originalData = [];
      }
    }
  }
};
</script>

<style scoped>

</style>